import { render, staticRenderFns } from "./GestaoInventario.vue?vue&type=template&id=bf93ebae"
import script from "./GestaoInventario.vue?vue&type=script&lang=js"
export * from "./GestaoInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports